import React from "react";
import { Button, Input } from "../../../../Components/StyledComponents";
import { onlyNum } from "../../../../Utils/functions";
import './CreateOption.scss';

const CreateOption = ({ createOption }) => {
    const [ name, setName ] = React.useState('')//옵션 이름
    const [ price, setPrice ] = React.useState(0)//옵션 가격
    const [ desc, setDesc ] = React.useState('')//옵션 설명

    //옵션 추가
    const post = () => {
        createOption({
            Name : name,
            Price : parseInt(price),
            Description : desc
        })
    }

    return (
        <div className="create-option">
            <div>
                <p className="label">옵션정보</p>
                <div className="row" style={{ marginTop : 16, marginBottom : 8 }}>
                    <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="예) 1인분, 300g 등" style={{ width : 202, marginRight : 16 }}/>
                    <label htmlFor={`price`} data-domain="원">
                        <Input htmlFor={`price`} value={price} onChange={(e) => setPrice(onlyNum(e.target.value))} placeholder="0" style={{ width : 202 }}/>
                    </label>
                </div>
                <div className="row">
                    <Input value={desc} onChange={(e) => setDesc(e.target.value)} style={{ width : 420 }} placeholder='옵션에 대한 설명을 입력해주세요.'/>
                </div>
            </div>         

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} disabled={name.trim() === ''} onClick={() => post()}>
                    추가하기
                </Button>
            </div>
        </div>
    )
}

export default CreateOption;